export const RECOVERY_EMAIL_AD_TEST_ID = "recovery-email-ad";

export enum RECOVERY_EMAIL_AD_VARIANT {
  CONTROL = "control",
  MANDATORY = "mandatory",
  TRIGGER_WITH_GATING = "trigger-with-gating"
}
